export const wfBubble_master = { 
    current : {
        backgroundColor: '#007aff',
        borderColor: '#007aff',
        color: 'white',
    },
    visited : {
        backgroundColor: '#333',
        borderColor: '#333',
        color: 'white',
        cursor: 'pointer',
    },
    notVisited : {
        backgroundColor: 'white',
    }
}